const initializeMap = async (center, zoom, lat, lng) => {
    await loadGoogleMaps();
 
    if (typeof google === "undefined" || !google.maps.Map) {
        console.error("Google Maps is not available yet.");
        return;
    }
    const mapElement = findExerciseLocationMap.mapElement;

    if (mapElement) {
        mapElement.style.height = "80dvh";
        
        if (!center) {
            const hasLatLng = lat != null && lng != null;
            
            if (!hasLatLng) {
                const defaultCenter = getDefaultCenterByLanguage();
                center = { lat: defaultCenter.lat, lng: defaultCenter.lng };

            } else {
                center = { lat, lng };
            }
            zoom = zoom || 6;
        }

        const mapOptions = {
            center: center,
            zoom: zoom || 6,
            mapId: "DEMO_MAP_ID",
            mapTypeId: 'roadmap',
        };

        if (!findExerciseLocationMap.initialMapState.center) {
            findExerciseLocationMap.initialMapState.center = center;
            findExerciseLocationMap.initialMapState.zoom = zoom || 10;
        }

        if (findExerciseLocationMap.map) {
            findExerciseLocationMap.map.setCenter(mapOptions.center);
            if (mapOptions.zoom) {
                findExerciseLocationMap.map.setZoom(mapOptions.zoom);
            }
        } else {
            try {
                findExerciseLocationMap.map = new google.maps.Map(mapElement, mapOptions);
            } catch (err) {
                console.error("Map init failed:", err);
            }
        }

        if (!google.maps.marker || !google.maps.marker.AdvancedMarkerElement) {
            console.error("AdvancedMarkerElement is not available.");
            return;
        }

        // Setup cluster so Google can paint markers
        if (!findExerciseLocationMap.clusterArray) {
            const clusterOptions = {
                gridSize: 30,
                zoomOnClick: false,
                maxZoom: 10,
                renderer: {
                    render: ({ count, position }) => {
                        return new google.maps.marker.AdvancedMarkerElement({
                            map: findExerciseLocationMap.map,
                            position,
                            content: createClusterContent(count),
                            zIndex: typeof google.maps.Marker !== 'undefined' && Number.isFinite(google.maps.Marker.MAX_ZINDEX)
                                ? google.maps.Marker.MAX_ZINDEX + count
                                : 1000 + count,
                        });
                    }
                }
            };

            findExerciseLocationMap.clusterArray = new markerClusterer.MarkerClusterer({
                map: findExerciseLocationMap.map,
                markers: [],
                ...clusterOptions
            });
        }

       await buildMarkers(mapElement)

        if (findExerciseLocationMap.savedInputValue) {
            findGeoCodingResults(findExerciseLocationMap.savedInputValue);
        } else handleUrlParameters();
       
    }
}
